import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { News } from '@app/entity/news';
import { Event } from '@app/entity/event';

import { Observable } from 'rxjs/Observable';
import { Question } from '@app/entity/faq';
import { API_VERSION } from '@app/core/api.version';
import { map } from 'rxjs/operators';

export type SearchType = 'news' | 'event' | 'question' | 'section';

export interface SearchObject extends News, Event, Question {
  type: SearchType;
  routerLink?: string;
}

const SITE_SECTIONS: SearchObject[] = [
  {text: 'информация', routerLink: '/about', type: 'section'},
  // {text: 'вопросы и ответы', routerLink: '/about', type: 'section'},
  {text: 'помощь', routerLink: '/social-support', type: 'section'},
  // {text: 'помощь юриста', routerLink: '/social-support/consults', type: 'section'},
  // {text: 'помощь психолога', routerLink: '/social-support/psycho-help', type: 'section'},
  // {text: 'помощь государства', routerLink: '/social-support/services', type: 'section'},
  // {text: 'ветеранские организации', routerLink: '/social-support/organizations', type: 'section'},
  // {text: 'помощь от волонтера', routerLink: '/social-support/help-from-volunteers', type: 'section'},
  // {text: 'помощь от фонда', routerLink: '/social-support/help-from-fund', type: 'section'},
  {text: 'новости', routerLink: '/magazine/news', type: 'section'},
  // {text: 'праздники и памятные даты', routerLink: '/magazine/events', type: 'section'},
  {text: 'отзывы', routerLink: '/feedbacks', type: 'section'},
];

@Injectable()
export class SearchService {

  constructor(private http: HttpClient) {}

  search(keywords: string, pageSize?: number): Observable<SearchObject[]> {
    let params = new HttpParams();
    params = params.set('q', keywords);
    if (pageSize) params = params.set('page_size', pageSize + '');
    return this.http.get<SearchObject[]>(`/${API_VERSION}/search/`, { params })
      .pipe(map(res => res = res.concat(SITE_SECTIONS.filter(item => item.text.includes(keywords.toLocaleLowerCase())))));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/search.service.ts